// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-addon {
  border-bottom: 1px solid #DB686E;
  display: inline-block;
  max-width: 10rem;
  cursor: pointer;
}
.select-addon .custom-select {
  font-size: 16px;
  font-weight: 400;
  line-height: 20.83px;
  letter-spacing: 0.03em;
  color: #AAAAAA;
}
.select-addon .custom-select span {
  cursor: pointer;
}

.special-addon-option:hover {
  color: #DB686E;
  cursor: pointer;
}

.addon-active {
  color: #DB686E;
  text-decoration: underline;
  text-underline-offset: 4px;
}

.apply-btn {
  background-color: #DB686E !important;
  color: white;
}

.cabin-detail-wrapper .deck-room-wrapper .custom-label {
  font-size: 14px;
  color: #7a7a7a;
}
.cabin-detail-wrapper .deck-room-wrapper .custom-select {
  height: 26px;
}
.cabin-detail-wrapper .deck-room-wrapper .custom-select .selected-item {
  padding-top: 0;
}
.cabin-detail-wrapper .deck-room-wrapper .custom-select .selected-item .select-placeholder {
  font-size: 14px;
}
.cabin-detail-wrapper .deck-room-wrapper .custom-select .options-container .options-list li {
  line-height: 28px;
}`, "",{"version":3,"sources":["webpack://./src/pages/AddLeads/stepThree/Components/style.scss"],"names":[],"mappings":"AAAA;EACI,gCAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;AACJ;AACI;EACI,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,cAAA;AACR;AACQ;EACI,eAAA;AACZ;;AAIA;EACI,cAAA;EACA,eAAA;AADJ;;AAGA;EACI,cAAA;EACA,0BAAA;EACA,0BAAA;AAAJ;;AAGA;EACI,oCAAA;EACA,YAAA;AAAJ;;AAKQ;EACI,eAAA;EACA,cAAA;AAFZ;AAKQ;EACI,YAAA;AAHZ;AAKY;EACI,cAAA;AAHhB;AAKgB;EACI,eAAA;AAHpB;AASoB;EACI,iBAAA;AAPxB","sourcesContent":[".select-addon {\n    border-bottom: 1px solid #DB686E;\n    display: inline-block;\n    max-width: 10rem;\n    cursor: pointer;\n\n    .custom-select {\n        font-size: 16px;\n        font-weight: 400;\n        line-height: 20.83px;\n        letter-spacing: 0.03em;\n        color: #AAAAAA;\n\n        span {\n            cursor: pointer;\n        }\n    }\n\n}\n.special-addon-option:hover{\n    color: #DB686E;\n    cursor: pointer;\n}\n.addon-active {\n    color: #DB686E;\n    text-decoration: underline;\n    text-underline-offset: 4px;\n}\n\n.apply-btn {\n    background-color: #DB686E !important;\n    color: white;\n}\n\n.cabin-detail-wrapper{\n    .deck-room-wrapper{\n        .custom-label{\n            font-size: 14px;\n            color: #7a7a7a;\n        }\n\n        .custom-select{\n            height: 26px;\n\n            .selected-item{\n                padding-top: 0;\n\n                .select-placeholder{\n                    font-size: 14px;\n                }\n            }\n\n            .options-container{\n                .options-list{\n                    li{\n                        line-height: 28px;\n                    }\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
